import { isValidElement, Children, useCallback, useRef, useState, } from 'react';
export function getValidChildren(children) {
    return Children.toArray(children).filter(child => isValidElement(child));
}
export function isFunction(value) {
    return typeof value === 'function';
}
export function runIfFn(valueOrFn, ...args) {
    return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
export function useGetLatest(val) {
    const ref = useRef(val);
    ref.current = val;
    return useCallback(() => ref.current, []);
}
const noop = () => {
};
export function useControlledState({ initial, value, onChange = noop, }) {
    if (initial === undefined && value === undefined) {
        throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
    }
    const [state, setState] = useState(initial);
    const getLatest = useGetLatest(state);
    const set = useCallback((updater) => {
        const state = getLatest();
        const updatedState = typeof updater === 'function' ? updater(state) : updater;
        if (typeof updatedState.persist === 'function')
            updatedState.persist();
        setState(updatedState);
        if (typeof onChange === 'function')
            onChange(updatedState);
    }, [getLatest, onChange]);
    const isControlled = value !== undefined;
    return [isControlled ? value : state, isControlled ? onChange : set];
}
//# sourceMappingURL=react-utils.js.map